import { render, staticRenderFns } from "./OldHomePage.vue?vue&type=template&id=58d84b58&scoped=true"
import script from "./OldHomePage.vue?vue&type=script&lang=js"
export * from "./OldHomePage.vue?vue&type=script&lang=js"
import style0 from "./OldHomePage.vue?vue&type=style&index=0&id=58d84b58&prod&lang=scss"
import style1 from "./OldHomePage.vue?vue&type=style&index=1&id=58d84b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d84b58",
  null
  
)

export default component.exports